import { create } from "zustand";

type Message = {
  id: number,
  message: string,
  code?: number,
  variant?: "error" | "info" | "success" | "warning" | "default";
}

type MessagesState = {
  messages: Message[],
  lastMessage: Message | null,
}

type MessagesActions = {
  addError: (message: string, code?: number) => void;
  clearErrors: () => void;
  addSuccess: (message: string) => void;
}

const initialUserState: MessagesState = {
  messages: [],
  lastMessage: null,
}

const getId = () => Math.trunc(Math.random() * 10e6);

export const useMessagesStore = create<MessagesState & MessagesActions>((set) => ({

  ...initialUserState,

  addError: (message: string, code?: number) => set((state) => {
    const newError: Message = {
      id: getId(),
      message,
      code,
      variant: "error",
    }
    return {
      ...state,
      lastMessage: newError,
      messages: [...state.messages, newError]
    }
  }),

  addSuccess: (message: string) => set((state) => {
    const newMessage: Message = {
      id: getId(),
      message,
      variant: "success",
    }
    return {
      ...state,
      lastMessage: newMessage,
      messages: [...state.messages, newMessage]
    }
  }),


  clearErrors: () => set(() => ({ messages: [] }))

}));
